import {generateFetchOptions} from '../index';

// POST /api/v1/oauth/linkedin/authorization
export async function authorize(provider: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/users/oauth/${provider}/authorization`,
    generateFetchOptions({
      method: 'POST',
      isProtected: true,
    })
  );
}

export async function authorizeSignup(provider: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/users/oauth/${provider}/signup/authorization`,
    generateFetchOptions({
      method: 'POST',
      isProtected: false,
    })
  );
}
